// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InputHighlight.css - Styling for highlighting the chat input field */

@keyframes input-highlight-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.25);
  }
}

.highlight-border {
  border-color: #3B82F6 !important; /* Blue 500 */
  border-width: 2px !important;
  animation: input-highlight-pulse 2s ease-in-out infinite;
}

.dark .highlight-border {
  border-color: #60A5FA !important; /* Blue 400 */
}`, "",{"version":3,"sources":["webpack://./src/styles/InputHighlight.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,gCAAgC,EAAE,aAAa;EAC/C,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC,EAAE,aAAa;AACjD","sourcesContent":["/* InputHighlight.css - Styling for highlighting the chat input field */\n\n@keyframes input-highlight-pulse {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.25);\n  }\n}\n\n.highlight-border {\n  border-color: #3B82F6 !important; /* Blue 500 */\n  border-width: 2px !important;\n  animation: input-highlight-pulse 2s ease-in-out infinite;\n}\n\n.dark .highlight-border {\n  border-color: #60A5FA !important; /* Blue 400 */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
